(function () {
    // 注册组件
    SR.modules.extend('loadTheaterScript', loadTheaterScript);

    function loadTheaterScript() {
        var theaterScripts = SR.util.getStorage('theaterScripts');
        var currentTheaterScript;
        var isNewUser = false;
        if (theaterScripts) {
            $(theaterScripts).each(function(index) {
                var script = this;
                if (script.hasVisited || !script.valid || !script.lines || !script.lines.length) {
                    return;
                }
                if (index === 0) {
                    isNewUser = true;
                }
                currentTheaterScript = script;
                script.hasVisited = true;
            });
            if (isNewUser) {
                // 新用户只展示新手教程
                $(theaterScripts).each(function(index) {
                    this.hasVisited = true;
                });
                currentTheaterScript = theaterScripts[0];
            }
            SR.util.updateStorage('theaterScripts', theaterScripts);
        }
        return currentTheaterScript;
    }
}());